module.exports = __webpack_public_path__ + "img/icon-shrink-vertical.cbfb8404.svg";